import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import openPositionsApi from "../../services/Api/openPositionsApi";

export const addNewPosition = createAsyncThunk(
    "openPositions/addNew",
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await openPositionsApi.addNewPosition(payload);
            console.log("ddddd", data)
            return data;
        } catch (err) {
            const message =
                "Something went wrong";
            return rejectWithValue(message);
        }
    }
);

export const getPositions = createAsyncThunk(
    "openPositions/getPositions",
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await openPositionsApi.getAllPositions();
            return data;
        } catch (err) {
            const message =
                "Something went wrong";
            return rejectWithValue(message);
        }
    }
);
export const updatePosition = createAsyncThunk(
    "openPositions/updatePosition",
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await openPositionsApi.updatePosition(payload);
            return data;
        } catch (err) {
            const message =
                "Something went wrong";
            return rejectWithValue(message);
        }
    }
);


const openPositionsSlice = createSlice({
    name: "openPositions",
    initialState: {
        loading: false,
        data: null,
        error: null,
        allPositions:[],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addNewPosition.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addNewPosition.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(addNewPosition.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getPositions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPositions.fulfilled, (state, action) => {
                state.loading = false;
                state.allPositions = action.payload.company_positions_data;
            })
            .addCase(getPositions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default openPositionsSlice.reducer;
